import { gql } from '@apollo/client';

export const GET_CURRENT_USER_ORGANISATIONS = gql`
  query GetCurrentUserOrganisations($input: OrganisationFilterArgs!) {
    organisations: getCurrentUserOrganisations(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id

          isFunder
          isInstitution
          isServiceProvider

          funder {
            id
            name
          }
          institution {
            id
            name
          }
          serviceProvider {
            id
            name
          }
        }
      }
    }
  }
`;
